import React from 'react';
import Lottie from 'lottie-react';
import LottieFromUrl from '../../../components/LottieFromUrl/LottieFromUrl';
import yetiHappyDanceJson from '../../../appAssets/jsons/YetiHappyDance.json';
import chatObjectJson from '../../../appAssets/jsons/chatObject.json';
import homeBtnImg from '../../../appAssets/homeBtn.png';
import closeIcon from '../../../appAssets/closeIcon.png';
import WebAudioPlayer from '../../WebStoryScreen/Components/WebAudioPlayer';
import WebShadowButton from '../../WebStoryScreen/Components/WebShadowButton';

interface EndModalProps {
  title: string;
  animationUrl: string | null;
  onHome: () => void;
  onRestart: () => void;
  audioUrl?: string | null;
}

const EndModal: React.FC<EndModalProps> = ({
  title,
  animationUrl,
  onHome,
  onRestart,
  audioUrl,
}) => {
  const isLarge = window.innerWidth >= 768;
  const modalWidth = window.innerWidth * 0.6;
  const modalHeight = window.innerHeight * 0.8;
  const animSize = Math.round(modalHeight * 0.5);
  const titleSize = isLarge ? 26 : 20;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: 28,
        padding: isLarge ? 36 : 24,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 10px 40px rgba(0,0,0,0.25)',
        border: '2px solid #E0E0E0',
        width: modalWidth,
        height: modalHeight,
        boxSizing: 'border-box',
      }}>

        {/* Header */}
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 8, width: '100%'}}>
          <p style={{
            flex: 1,
            fontFamily: 'Mochiy Pop One',
            fontSize: titleSize,
            fontWeight: 700,
            color: '#1a1a1a',
            textAlign: 'center',
            lineHeight: 1.4,
            margin: 0,
          }}>
            {title}
          </p>
          <button
            style={{background: 'none', border: 'none', cursor: 'pointer', padding: 4, flexShrink: 0}}
            onClick={onHome}>
            <img src={closeIcon} alt="close" style={{width: isLarge ? 28 : 22, height: isLarge ? 28 : 22}} />
          </button>
        </div>

        {/* Animation — fills the middle */}
        <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          {animationUrl ? (
            <>
              <LottieFromUrl
                url={animationUrl}
                className="end-modal-anim"
                fallback={yetiHappyDanceJson}
              />
              <style>{`.end-modal-anim { width: ${animSize}px; height: ${animSize}px; }`}</style>
            </>
          ) : (
            <Lottie
              animationData={yetiHappyDanceJson}
              style={{width: animSize, height: animSize}}
              loop
            />
          )}
        </div>

      

        {/* Buttons */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: isLarge ? 20 : 12,
          flexWrap: 'wrap',
          width: '100%',
        }}>
          <WebShadowButton
            variant="outline"
            title="No, not now"
            icon={<img src={homeBtnImg} alt="" style={{width: isLarge ? 24 : 20, height: isLarge ? 24 : 20}} />}
            onPress={onHome}
          />

          <WebShadowButton
            variant="text"
            title="Yes, let's go!"
            icon={<Lottie animationData={chatObjectJson} style={{width: isLarge ? 30 : 24, height: isLarge ? 30 : 24}} loop />}
            onPress={onRestart}
          />
        </div>

        {audioUrl ? <WebAudioPlayer key={audioUrl} uri={audioUrl} /> : null}
      </div>
    </div>
  );
};

export default EndModal;
